import React from "react";
const SearchIcon = () => {
  return (
    <>
      <svg
        width='25'
        height='25'
        viewBox='0 0 25 25'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M24 24L16.3333 16.3333L24 24ZM18.8889 9.94444C18.8889 11.119 18.6575 12.2821 18.208 13.3673C17.7585 14.4525 17.0997 15.4386 16.2691 16.2691C15.4386 17.0997 14.4525 17.7585 13.3673 18.208C12.2821 18.6575 11.119 18.8889 9.94444 18.8889C8.76984 18.8889 7.60674 18.6575 6.52155 18.208C5.43636 17.7585 4.45034 17.0997 3.61977 16.2691C2.7892 15.4386 2.13036 14.4525 1.68086 13.3673C1.23136 12.2821 1 11.119 1 9.94444C1 7.57223 1.94236 5.29718 3.61977 3.61977C5.29718 1.94236 7.57223 1 9.94444 1C12.3167 1 14.5917 1.94236 16.2691 3.61977C17.9465 5.29718 18.8889 7.57223 18.8889 9.94444Z'
          stroke='#726D82'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </>
  );
};
export default SearchIcon;
